"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var Header = function Header(_ref) {
  var displayName = _ref.displayName,
    buttonText = _ref.buttonText,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-header"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "revisions-header__text"
  }, "Change Plan for ", /*#__PURE__*/_react.default.createElement("span", null, displayName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-header__nav"
  }, onCancel && /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    variant: "tertiary",
    onClick: onCancel
  }, buttonText)));
};
Header.propTypes = {
  displayName: _propTypes.default.string.isRequired,
  buttonText: _propTypes.default.string,
  onCancel: _propTypes.default.func
};
Header.defaultProps = {
  buttonText: 'Back to Dashboard',
  onCancel: null
};
var _default = exports.default = Header;
